export default {
  addDate,          //获取当前日期
  is_Auth,          //判断是否有按钮权限
  is_num,           //判断字符串是不是全是数字
  isSpace,          //判断字符串里面有没有空格
  convert,          //根据一维数组的number1字段编排为二维数组
  checkIntAndFloat, //验证是否是整数或小数
  checkNofh,/*不能有符号*/
  noBq,
  checkSpace
}

function checkSpace(source) {
  var regex = /\s/g;
  return regex.test(source);
}

function noBq(){
  return /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
}

function checkNofh(val){
  return RegExp(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g).test(val);
}

function checkIntAndFloat(source){
  var regex = /^[0-9]+(\.[0-9]+)?$/g;
  return regex.test(source);
}

// 转换后的二维数组
function convert (arr) {
  var map1 = {};
  while(arr.length) {
    let current = arr.pop(); // 会影响原数组
    map1[current.number1] = map1[current.number1] || [];
    map1[current.number1].push(current);
  }

  return Object.keys(map1).map(key => map1[key]);
}

/**
 * 判断字符串里是否有空格
 * @param {Object} data
 */
function isSpace(str) {
  if (str.indexOf(" ") == -1) {
    return false;
  } else {
    return true;
  }
}

function addDate() {
  nowDate = new Date();
  let date = {
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
    date: nowDate.getDate(),
  }
  console.log(date);
  let systemDate = date.year + '-' + 0 + date.month + '-' + 0 + date.date;
  return systemDate;
}

function is_Auth(data,name,names) {
  let i = false;
  data.forEach(function (item,index) {
    if (item.name == name) {
      item.sonList.forEach(function (items,indexs) {
        if (items.name == names) {
          i = true;
        }
      })
    }
  })
  return i;
}

function is_num(str) {
  var regPos = /^\d+(\.\d+)?$/; //非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
  if(regPos.test(str) || regNeg.test(str)) {
    return true;
  } else {
    return false;
  }
}